import { Sell } from "../../domain/models/Sell";

export const sellDataToCsv = (data: Sell[], isResume: boolean = true) => {



    let csv: Array<Array<any>> = [];
    if (!isResume) {
        csv.push(['Fecha y hora', 'Sku', 'Proveedor', 'Descripción', 'Monto', 'Comisión', 'Destino', 'Confirmación', 'Usuario',]);
    } else {
        csv.push(['Fecha y hora', 'ID', 'Descripción', 'Origen', 'Destino', 'Monto', 'Referencia']);
    }

    data.forEach((item: Sell) => {
        if (!isResume) {
            csv.push([
                item.date_hour,
                item.sku,
                item.carrier,
                item.description,
                item.amount,
                item.comision,
                item.destination,
                item.confirmation,
                item.uid ?? '-'
            ]);
        } else {
            csv.push([
                item.date_hour,
                item.operation_id,
                item.description,
                item.origin,
                item.destination,
                item.amount,
                item.reference
            ]);
        }
    });
    return csv;
}
